import axios from "../../http/axios";
import * as actionTypes from "./actionTypes";
export const GET_ORDERS_PER_ZONE = "GET_ORDERS_PER_ZONE";
export const GET_REJECTED_ORDERS_PER_ZONE = "GET_REJECTED_ORDERS_PER_ZONE";
export const GET_SEARCH_ORDERS_PER_ZONE = "GET_SEARCH_ORDERS_PER_ZONE";

export function getOrdersPerZone(token) {
  const request = axios.get(
    `/reports-order-per-zone/`,
    {
      headers: { Authorization: "JWT " + token }
    }
  );
  return dispatch =>
    request
      .then(res =>
        dispatch({
          type: GET_ORDERS_PER_ZONE,
          payload: res.data
        })
      )
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
}
export function getRejectedOrdersPerZone(token, id, page) {
  const request = axios.get(
    `/rejected-order-per-zone/?zone=${id}&page=${page}`,
    {
      headers: { Authorization: "JWT " + token }
    }
  );
  return dispatch =>
    request
      .then(res =>
        dispatch({
          type: GET_REJECTED_ORDERS_PER_ZONE,
          payload: res.data
        })
      )
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
}

export function getSearchOrdersPerZone(token, value, type) {
  const request = axios.get(
    `/reports-order-per-zone/?${
      type ? `type=${type}` : ""
    }${value ? `&search=${value}` : ""}  `,
    {
      headers: { Authorization: "JWT " + token }
    }
  );
  return dispatch =>
    request
      .then(res =>
        dispatch({
          type: GET_SEARCH_ORDERS_PER_ZONE,
          payload: res.data
        })
      )
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
}



// WEBPACK FOOTER //
// ./src/store/actions/orderReports.js